// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"370":"18f3aa7d","697":"a558c8ac","820":"5e397565","945":"f47ea361"}[chunkId] + ".chunk.js";
};